/*
  Fator 5 — Tabela Olfativa na home (sections/tabela-olfativa-home.liquid): busca rápida, atalhos e exemplos
  que se digitam sozinhos no campo. O motor da busca fica em assets/busca-olfativa.js.
  Antes vinha embutido no HTML da home. Aqui fica em cache e roda com defer, logo depois do motor (os dois
  têm defer e rodam na ordem em que aparecem). O motor só é usado quando a tabela chega, depois do 1º gesto.
*/
(function () {
  function norm(s) { return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim(); }
  function motor() { return window.BuscaOlfativa; }
  function celular() { return window.matchMedia('(max-width: 767px)').matches; }
  function cabe(linha) { return linha.scrollWidth <= linha.clientWidth + 1; }
  var SETA = '<svg class="tolh__seta" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  /* Texto de um atributo do HTML baixado (desfaz &amp;, &#39; etc.) */
  var caixa = null;
  function texto(s) {
    if (s.indexOf('&') < 0) { return s; }
    if (!caixa) { caixa = document.createElement('textarea'); }
    caixa.innerHTML = s;
    return caixa.value;
  }
  function linha(insp, nome, gen, href, i, aroma) {
    var d = { insp: insp, nome: nome, gen: gen, href: href, i: i, _i: norm(insp), _n: norm(nome) };
    if (motor()) {
      d.busca = motor().prepara(insp + ' ' + nome + ' ' + gen);
      /* tipo de cheiro (familia, materias-primas e notas) — deixa buscar por "amadeirado", "doce", "sandalo" */
      d.aroma = motor().prepara(aroma || '');
    }
    return d;
  }
  /* Apelidos que o marketing escreve no editor da página da Tabela Olfativa (vêm junto no HTML baixado) */
  function leApelidos(html) {
    var m = /data-to-apelidos="([^"]*)"/.exec(html);
    var txt = m ? m[1].replace(/&#10;|&#13;/g, '\n').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&') : '';
    return motor() ? motor().leApelidos(txt) : [];
  }
  /* Lê as linhas da tabela do HTML baixado sem montar a página inteira em memória */
  function leLinhas(html) {
    var ini = html.indexOf('data-to-body');
    var fim = ini < 0 ? -1 : html.indexOf('</tbody>', ini);
    var trecho = (ini >= 0 && fim > ini) ? html.slice(ini, fim) : html;
    var re = /<tr class="to__row[^>]*?data-gen="([^"]*)"[^>]*?data-insp="([^"]*)"[^>]*?data-nome="([^"]*)"([^>]*)>/g;
    var lista = [];
    var m;
    while ((m = re.exec(trecho))) {
      var href = /data-href="([^"]*)"/.exec(m[4]);
      var aroma = /data-aroma="([^"]*)"/.exec(m[4]);
      lista.push(linha(texto(m[2]), texto(m[3]), texto(m[1]), href ? texto(href[1]) : '', lista.length, aroma ? texto(aroma[1]) : ''));
    }
    if (lista.length) { return lista; }
    /* Plano B: se a tabela mudar de formato, lê pelo caminho normal */
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.prototype.map.call(doc.querySelectorAll('.to__row'), function (tr, i) {
      return linha(tr.getAttribute('data-insp') || '', tr.getAttribute('data-nome') || '', tr.getAttribute('data-gen') || '', tr.getAttribute('data-href') || '', i, tr.getAttribute('data-aroma') || '');
    });
  }

  function inicia(root) {
    if (root._tolh) { return; }
    root._tolh = true;
    var url = root.getAttribute('data-tabela-url');
    var form = root.querySelector('[data-tolh-form]');
    var q = root.querySelector('[data-tolh-q]');
    var res = root.querySelector('[data-tolh-res]');
    var st = root.querySelector('[data-tolh-status]');
    var sug = root.querySelector('[data-tolh-sug]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tolh-chip]'));
    var dados = null;
    var apelidos = [];
    var pedido = null;
    var falhou = false;
    var ultimo = '';
    var espera = null;
    var atual = null;
    var larguraAntes = window.innerWidth;
    var io = null;
    var timer = null;
    var naTela = true;

    function linkBusca(termo) { return url + (url.indexOf('?') < 0 ? '?' : '&') + 'busca=' + encodeURIComponent(termo); }

    /* Baixa a página da Tabela Olfativa uma vez. Se falhar, não insiste a cada tecla: mostra o link e pronto. */
    function carrega() {
      if (falhou) { return Promise.reject(new Error('tabela indisponível')); }
      if (!pedido) {
        var ctrl = ('AbortController' in window) ? new AbortController() : null;
        var corte = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
        pedido = fetch(url, ctrl ? { credentials: 'same-origin', signal: ctrl.signal } : { credentials: 'same-origin' })
          .then(function (r) { if (corte) { clearTimeout(corte); } if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); })
          .then(function (html) {
            apelidos = leApelidos(html);
            dados = leLinhas(html);
            if (!dados.length) { throw new Error('tabela vazia'); }
            return dados;
          })
          .catch(function (e) { if (corte) { clearTimeout(corte); } pedido = null; dados = null; falhou = true; throw e; });
      }
      return pedido;
    }

    /* Busca tolerante (acento, começo de palavra, letras trocadas, apelidos): ver assets/busca-olfativa.js.
       `certos` é o que o cliente escreveu direito; `parecidos` só aparece quando não houve nenhum certo. */
    function procura(txt) {
      if (motor()) {
        var r = motor().busca(dados, txt, apelidos);
        var lista = r.diretos.length ? r.diretos : r.sugestoes;
        return {
          certos: r.diretos.map(function (x) { return x.item; }),
          parecidos: r.sugestoes.map(function (x) { return x.item; }),
          cheiro: lista.length > 0 && !!lista[0].aroma
        };
      }
      var t = norm(txt);
      return { certos: dados.filter(function (d) { return d._i.indexOf(t) >= 0 || d._n.indexOf(t) >= 0; }), parecidos: [], cheiro: false };
    }

    function el(tag, cls, conteudo) {
      var e = document.createElement(tag);
      if (cls) { e.className = cls; }
      if (conteudo != null) { e.textContent = conteudo; }
      return e;
    }

    /* Computador: atalhos que não cabem na linha ficam de fora (no celular a linha rola para o lado) */
    function ajustaAtalhos() {
      if (!sug || sug.hidden) { return; }
      chips.forEach(function (c) { c.style.display = ''; });
      if (celular()) { return; }
      for (var i = chips.length - 1; i > 0 && !cabe(sug); i--) { chips[i].style.display = 'none'; }
    }

    /* Resultados no lugar dos atalhos (e os atalhos voltam quando o campo fica vazio).
       Se o foco estava num atalho, ele vai para o campo antes de o atalho sumir. */
    function abre() {
      if (sug && !sug.hidden && sug.contains(document.activeElement)) { q.focus(); }
      res.hidden = false;
      if (sug) { sug.hidden = true; }
      res.scrollLeft = 0;
    }
    function fecha() {
      res.hidden = true;
      res.innerHTML = '';
      atual = null;
      if (sug) { sug.hidden = false; }
      ajustaAtalhos();
    }

    function mensagem(txt, comLink, aviso) {
      atual = null;
      res.innerHTML = '';
      var li = el('li', 'tolh__msg', txt);
      if (comLink) {
        li.appendChild(document.createTextNode(' '));
        var a = el('a', '', 'Ver a tabela completa');
        a.href = comLink;
        li.appendChild(a);
      }
      res.appendChild(li);
      abre();
      if (aviso != null) { st.textContent = aviso; }
    }

    /* Cada resultado vira um botão curto: nome em negrito + perfume de inspiração sem a marca ("Perfume 05 Bleu de Chanel").
       Até 5; no computador, só os que cabem numa linha, e o "Ver todos (N)" leva o resto para a tabela. */
    function monta(lista, termo, qtd) {
      res.innerHTML = '';
      lista.slice(0, qtd).forEach(function (d) {
        var li = el('li');
        var a = el('a', 'tolh__item');
        a.href = d.href || linkBusca(d.nome);
        a.appendChild(el('span', 'tolh__nome', d.nome));
        a.appendChild(el('span', 'tolh__insp', d.insp.split(/\s[-–]\s/)[0]));
        a.appendChild(el('span', 'visually-hidden', ', inspirado em ' + d.insp));
        li.appendChild(a);
        res.appendChild(li);
      });
      if (lista.length > qtd) {
        var li2 = el('li');
        var a2 = el('a', 'tolh__item tolh__item--todos');
        a2.href = linkBusca(termo);
        a2.appendChild(el('span', '', 'Ver todos (' + lista.length + ')'));
        a2.appendChild(el('span', 'visually-hidden', ' os resultados na tabela'));
        a2.insertAdjacentHTML('beforeend', SETA);
        li2.appendChild(a2);
        res.appendChild(li2);
      }
    }
    function desenha(lista, termo) {
      atual = { lista: lista, termo: termo };
      var qtd = Math.min(lista.length, 5);
      monta(lista, termo, qtd);
      abre();
      if (celular()) { return; }
      while (qtd > 1 && !cabe(res)) { qtd--; monta(lista, termo, qtd); }
    }

    function mostra(txt) {
      var t = norm(txt);
      ultimo = t;
      if (!t) { fecha(); st.textContent = ''; return; }
      if (falhou) { mensagem('Não foi possível buscar agora.', linkBusca(txt.trim()), 'Não foi possível buscar agora. Abra a tabela completa.'); return; }
      if (!dados) { mensagem('Buscando…', null, 'Buscando…'); }
      carrega().then(function () {
        if (ultimo !== t) { return; }
        var r = procura(txt);
        var aproximado = r.certos.length === 0 && r.parecidos.length > 0;
        var achados = r.certos.length ? r.certos : r.parecidos;
        if (!achados.length) {
          mensagem('Não encontramos “' + txt.trim() + '”.', url, 'Nenhum perfume encontrado.');
          return;
        }
        desenha(achados, txt.trim());
        if (aproximado) {
          st.textContent = 'Nada exato para “' + txt.trim() + '”. Mostrando ' + achados.length + (achados.length === 1 ? ' parecido.' : ' parecidos.');
        } else {
          st.textContent = achados.length === 1 ? '1 perfume encontrado.' : achados.length + ' perfumes encontrados.';
        }
      }, function () {
        if (ultimo !== t) { return; }
        mensagem('Não foi possível buscar agora.', linkBusca(txt.trim()), 'Não foi possível buscar agora. Abra a tabela completa.');
      });
    }

    /* Exemplos que se digitam sozinhos no campo. Param de vez assim que o cliente usa o campo,
       e só rodam com o bloco na tela e a aba em primeiro plano (nunca com "reduzir movimento").
       Dão uma volta só: cada letra refaz o layout do campo, e sem fim a página nunca ficava parada. */
    var exemplos = chips.map(function (b) { return b.textContent.trim(); }).filter(Boolean);
    var calmo = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var phCheio = q.getAttribute('placeholder') || '';
    var ex = 0;
    var n = exemplos.length ? exemplos[0].length : 0;
    var apagando = false;
    var pausa = 14;
    function passo() {
      if (!root.isConnected || document.activeElement === q || q.value) { paraExemplos(); return; }
      var w = exemplos[ex % exemplos.length];
      if (pausa > 0) { pausa--; return; }
      if (apagando) {
        n--;
        if (n <= 0) { apagando = false; ex++; pausa = 3; }
      } else {
        n++;
        if (n >= w.length) {
          /* Fim da volta: o primeiro exemplo está escrito de novo, igual ao texto fixo do campo */
          if (ex === exemplos.length) { paraExemplos(); return; }
          apagando = true; pausa = 14;
        }
      }
      q.placeholder = 'Ex.: ' + exemplos[ex % exemplos.length].slice(0, Math.max(n, 0));
    }
    function ligaExemplos() { if (!timer && !calmo && naTela && !document.hidden && exemplos.length > 1) { timer = setInterval(passo, 90); } }
    function desligaExemplos() { if (timer) { clearInterval(timer); timer = null; } }
    function paraExemplos() { desligaExemplos(); exemplos = []; q.placeholder = phCheio; }
    function aoVisibilidade() { if (document.hidden) { desligaExemplos(); } else { ligaExemplos(); } }

    q.addEventListener('input', function () {
      paraExemplos();
      clearTimeout(espera);
      espera = setTimeout(function () { mostra(q.value); }, 120);
    });
    q.addEventListener('focus', paraExemplos);
    chips.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) { return; }
        e.preventDefault();
        paraExemplos();
        q.value = b.textContent.trim();
        mostra(q.value);
      });
    });
    form.addEventListener('submit', function (e) {
      var t = norm(q.value);
      if (!t) { e.preventDefault(); window.location.href = url; return; }
      if (dados) {
        var achado = procura(q.value);
        /* So pula direto para o produto quando o unico acerto veio do NOME. Uma nota que aparece
           em um unico perfume (ex.: "vodka") nao pode teleportar o cliente para a pagina dele. */
        if (achado.certos.length === 1 && achado.certos[0].href && !achado.cheiro) {
          e.preventDefault();
          window.location.href = achado.certos[0].href;
        }
      }
    });

    /* Refaz o encaixe da linha quando a LARGURA muda (no celular a altura muda sozinha: barra do navegador, teclado) */
    function aoRedimensionar() {
      if (window.innerWidth === larguraAntes) { return; }
      larguraAntes = window.innerWidth;
      clearTimeout(espera);
      espera = setTimeout(function () {
        if (atual) { desenha(atual.lista, atual.termo); } else { ajustaAtalhos(); }
      }, 150);
    }
    window.addEventListener('resize', aoRedimensionar);
    document.addEventListener('visibilitychange', aoVisibilidade);
    ajustaAtalhos();
    /* A medida certa dos atalhos só existe depois que a fonte do site carrega */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(ajustaAtalhos).catch(function () {});
    }

    /* Baixa a tabela quando o cliente mostra intenção de buscar (mouse no bloco, foco, ou toque no campo/atalho),
       e não a cada dedo que encosta no bloco ao rolar a página. */
    function antecipa() { carrega().catch(function () {}); }
    root.addEventListener('pointerenter', antecipa, { once: true });
    root.addEventListener('focusin', antecipa, { once: true });
    q.addEventListener('touchstart', antecipa, { once: true, passive: true });
    chips.forEach(function (b) { b.addEventListener('touchstart', antecipa, { once: true, passive: true }); });

    if (!calmo && exemplos.length > 1) {
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(function (en) {
          naTela = en[0].isIntersecting;
          if (naTela) { ligaExemplos(); } else { desligaExemplos(); }
        });
        io.observe(root);
      } else {
        ligaExemplos();
      }
    }

    /* Editor de temas: ao trocar a seção, solta tudo o que ficou preso na página antiga */
    root._tolhLimpa = function () {
      window.removeEventListener('resize', aoRedimensionar);
      document.removeEventListener('visibilitychange', aoVisibilidade);
      desligaExemplos();
      clearTimeout(espera);
      if (io) { io.disconnect(); io = null; }
    };
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-tolh]'), inicia);

  /* Registra uma vez só por página, mesmo que o editor reexecute este script */
  if (!window.__tolhLigado) {
    window.__tolhLigado = true;
    document.addEventListener('shopify:section:load', function (e) {
      Array.prototype.forEach.call((e.target || document).querySelectorAll('[data-tolh]'), inicia);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call((e.target || document).querySelectorAll('[data-tolh]'), function (r) {
        if (r._tolhLimpa) { r._tolhLimpa(); }
      });
    });
  }
}());
